// For the allure images Product page
var adsImages = document.querySelectorAll('.flash_images img');
if(adsImages.length > 0){
  var timerChange = document.querySelector('.flash_images').getAttribute('data-timer');
  adsImages[0].classList.add('active');
  function imagesChange() {
    for(var i = 0; i < adsImages.length; i++) {
      if(adsImages[i].classList.contains("active")) {
        adsImages[i].classList.remove("active");
        if(i == adsImages.length - 1) {
          adsImages[0].classList.add("active");
        } else {
          adsImages[i + 1].classList.add("active");
        }
        break;
      }
    }
  }
  var myTimeout = setInterval(imagesChange,timerChange*1000);
  var mainAllureContainer = document.querySelector('.flash_images');
  mainAllureContainer.addEventListener("mouseenter", function(){
    clearTimeout(myTimeout);
  });
  mainAllureContainer.addEventListener("mouseleave", function(){
    myTimeout = setInterval(imagesChange,timerChange*1000);
  })
} 